import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'
import axios from 'axios'
import { Link, useNavigate } from 'react-router-dom'
import { toast, ToastContainer } from 'react-toastify'
import Select from 'react-select'
import 'react-toastify/dist/ReactToastify.css'
import Topbar from '../../layouts/Topbar'
import Sidebar from '../../layouts/Sidebar'
import apiConfig, { API_BASE_URL as NAMED_API_BASE_URL } from '../../../config/api'

const API_BASE_URL = typeof apiConfig === 'string' ? apiConfig : NAMED_API_BASE_URL || 'https://pms.burrayhr.com'

const CreateDepartment = () => {
  const navigate = useNavigate()
  const [costCenters, setCostCenters] = useState([])
  const [name, setName] = useState('')
  const [courseCenter, setCourseCenter] = useState(null)
  const [loading, setLoading] = useState(false)
  const [fetchingCenters, setFetchingCenters] = useState(true)
  const baseUrl = API_BASE_URL

  useEffect(() => {
    const fetchCostCenters = async () => {
      setFetchingCenters(true)
      try {
        const token = Cookies.get('token')
        const response = await axios.get(`${baseUrl}/api/course-centers/`, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        })
        const data = Array.isArray(response.data) ? response.data : []
        setCostCenters(data)
      } catch (err) {
        console.error('Failed to fetch cost centers', err)
        toast.error('Failed to fetch cost centers.')
      } finally {
        setFetchingCenters(false)
      }
    }
    fetchCostCenters()
  }, [baseUrl])

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (!name.trim() || !courseCenter) return

    setLoading(true)
    try {
      const token = Cookies.get('token')
      await axios.post(`${baseUrl}/api/departments/`, {
        name: name.trim(),
        course_center: courseCenter.value
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      toast.success('Department created successfully!')
      setName('')
      setCourseCenter(null)
      setTimeout(() => navigate('/hr/departments'), 1200)
    } catch (err) {
      console.error('Error creating department:', err)
      const errorMessage = err.response?.data?.message || err.response?.data?.detail || 'Failed to create department.'
      toast.error(errorMessage)
    } finally {
      setLoading(false)
    }
  }

  const costCenterOptions = costCenters.map(center => ({
    value: center.id,
    label: center.name
  }))

  return (
    <>
      <ToastContainer position="top-right" autoClose={3500} hideProgressBar={false} />
      <div data-sidebar-skin="dark" data-header-skin="light" data-navbar-brand-skin="dark" data-sidebar-state="expand">
        <Topbar />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content pb-0">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-4">
              <div>
                <h4 className="fw-bold mb-1">Add New Department</h4>
                <p className="text-muted mb-0 fs-13">Create a new department and assign it to a cost center</p>
              </div>
              <Link to="/hr/departments" className="btn btn-light">
                <i className="ti ti-arrow-left me-1" />
                Back to Departments
              </Link>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="card shadow-sm mb-4">
                <div className="card-header">
                  <h5 className="fw-bold mb-0">Department Details</h5>
                </div>
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label htmlFor="departmentName" className="form-label">
                        Department Name <span className="text-danger">*</span>
                      </label>
                      <input
                        id="departmentName"
                        type="text"
                        className="form-control"
                        placeholder="Enter department name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        disabled={loading}
                      />
                    </div>

                    <div className="col-md-6">
                      <label htmlFor="courseCenter" className="form-label">
                        Cost Center <span className="text-danger">*</span>
                      </label>
                      <Select
                        id="courseCenter"
                        classNamePrefix="react-select"
                        isLoading={fetchingCenters}
                        isDisabled={loading || fetchingCenters}
                        options={costCenterOptions}
                        value={courseCenter}
                        onChange={setCourseCenter}
                        placeholder={fetchingCenters ? 'Loading cost centers...' : 'Select a cost center'}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center justify-content-end gap-2 mb-4">
                <Link to="/hr/departments" className="btn btn-light" onClick={(e) => loading && e.preventDefault()}>
                  Cancel
                </Link>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={loading || !name.trim() || !courseCenter}
                >
                  {loading ? (
                    <>
                      <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                      Creating Department...
                    </>
                  ) : (
                    <>
                      <i className="ti ti-device-floppy me-1" />
                      Create Department
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>

          <div className="footer d-flex align-items-center justify-content-between flex-column flex-sm-row row-gap-2 border-top py-2 px-3">
            <p className="text-dark mb-0">
              2026 © <span className="link-primary">Casoe Technologies</span>, All Rights Reserved
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default CreateDepartment